<app-enfaf-modal
  [title]="title"
  svgIcon="pocket-modal"
  (onClose)="confirmCloseModal()"
  (onConfirm)="unassignCourses()"
  [isLoading]="isUnassigning"
  buttonConfirmText="Quitar acceso"
  [disableConfirmButton]="studentForm.invalid || isUnassigning"
>
  <form class="content" [formGroup]="studentForm" autocomplete="off">
    <div class="form-control-courses">
      <div class="courses-content">
        <enfaf-multi-autocomplete-light
          [fetchData]="fetchCourses.bind(this)"
          [selectedOptions]="selectedCourses"
          [placeholder]="'Buscar'"
          (selectedChanged)="onSelectedCoursesChanged($event)"
        >
        </enfaf-multi-autocomplete-light>
        @if (selectedCourses.length > 0) {
          <div class="selected-courses-list">
            @for (course of selectedCourses; track $index) {
              <div class="course-item">
                <span class="course-name">{{ course.title }}</span>
                <app-enfaf-icon
                  [svgIconName]="'trash-red'"
                  [iconSize]="'16px'"
                  [iconStyle]="{ color: '#E03131' }"
                  [isButton]="true"
                  (onClick)="removeCourse(course.id)"
                  class="remove-icon"
                >
                </app-enfaf-icon>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </form>
</app-enfaf-modal>
